import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { Observable, switchMap } from 'rxjs';
import { Endpoint } from '../configuration/endpoints';
import { DebtSourceEnum } from '../configuration/enums/company.enum';
import { SessionStorageService } from '../configuration/services/session-storage.service';
import { CacheKeys } from '../services/cache/cache-keys.enum';
import { selectDebtsSource } from '../store/states/company/company.selectors';

@Injectable()
export class RecaptchaInterceptor implements HttpInterceptor {
  private readonly recaptchaV3Service = inject(ReCaptchaV3Service);
  private readonly sessionStorageService = inject(SessionStorageService);
  private readonly store = inject(Store);

  private debtSourceSession = this.sessionStorageService.get<DebtSourceEnum>(
    CacheKeys.DEBT_SOURCE
  )!;
  private debtSourceStore = this.store.selectSignal(selectDebtsSource);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const debtSource = this.debtSourceSession || this.debtSourceStore();
    const shouldCaptchaInHeader = Endpoint.WITH_CAPTCHA(debtSource).find((endpoint) =>
      request.url.includes(endpoint)
    );

    const alwaysShouldCaptchaInHeader = Endpoint.ENDPOINTS_ALWAYS_HAVE_CAPTCHA().find((endpoint) =>
      request.url.includes(endpoint)
    );

    if (!shouldCaptchaInHeader && !alwaysShouldCaptchaInHeader) {
      return next.handle(request);
    }

    return this.recaptchaV3Service.execute('WLC').pipe(
      switchMap((token) => {
        const clonedRequest = request.clone({
          setHeaders: { 'captcha-token': token },
        });
        return next.handle(clonedRequest);
      })
    );
  }
}
